import { createSlice } from '@reduxjs/toolkit'

const initialState : any = {
    showUpdatePopup: false,
    showDetailsPopup: false
}

const controlsSlice = createSlice({
    name: 'controls',
    initialState,
    reducers: {
        manageUpdatePopup(state, {payload}) {
            state.showUpdatePopup = payload
        },
        manageDeatilsPopup(state, {payload}) {
            state.showDetailsPopup = payload
        }
    }
})

export const {manageUpdatePopup, manageDeatilsPopup} = controlsSlice.actions

export default controlsSlice.reducer
